import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, } from 'chart.js';
import { Line } from 'react-chartjs-2';

export default function MultiaxisLineChart({ chartData, monthly, color, title, ratio, bp }) {
    ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


    let labels
    let datasets
    let highestNumber = -Infinity;

    const colors = [
        '239, 71, 111',
        '255, 209, 102',
        '6, 214, 160',
        '17, 138, 178',
        '7, 59, 76'
    ];

    if (monthly) {
        labels = chartData?.labels?.map((label) => {
            const [month, year] = label.split("/")
            const date = new Date(Number(year), Number(month) - 1, 1)
            return date.toLocaleString('en-US', { month: 'short', year: 'numeric' })
        })
    } else {
        labels = chartData?.label
    }

    datasets = chartData?.dataset?.map((item, idx) => {
        return {
            label: item.label,
            data: item.data,
            borderColor: item.label !== 'Sales Commission' ? `rgb(${colors[idx]})` : `rgb(99, 102, 241)`,
            backgroundColor: item.label !== 'Sales Commission' ? `rgba(${colors[idx]}, 0.5)` : `rgba(99, 102, 241, 0.5)`,
            yAxisID: `y${idx+1}`,
        };
    });

    chartData?.dataset?.forEach((item) => {
        const maxNumber = Math.max(...item.data);
        if (maxNumber > highestNumber) {
            highestNumber = maxNumber;
        }
    });

    const options = {
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: true,
        },
        stacked: false,
        plugins: {
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                grid: {
                    display: true,
                    drawBorder: true
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'left',
                grid: {
                    display: true,
                    drawBorder: false
                },
                suggestedMin: 0,
                suggestedMax: highestNumber,
                title: {
                    display: true,
                    text: title,
                    font: {
                        size: '11',
                        weight: '500'
                    },
                    padding: {
                        bottom: 8
                    }
                },
            },
            y2: {
                display: false,
                suggestedMin: 0,
                suggestedMax: highestNumber, 
            },
            y3: {
                display: false,
                suggestedMin: 0,
                suggestedMax: highestNumber, 
            },
            y4: {
                display: false,
                suggestedMin: 0,
                suggestedMax: highestNumber, 
            },
            y5: {
                display: false,
                suggestedMin: 0,
                suggestedMax: highestNumber, 
            },
        },
        aspectRatio: ratio || 2.4
    }

    const data = {
        labels,
        datasets: datasets
    }

    return <Line options={options} data={data} />
}